import { Star, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { clickCta } from "@/lib/analytics";
import { trustAvatars } from "../WhyUsSection.data";

function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 48 48" aria-label="Google">
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      />
      <path
        fill="#FBBC05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      />
    </svg>
  );
}

interface TrustBarProps {
  onCtaClick?: () => void;
  showAvatars?: boolean;
}

export function TrustBar({ onCtaClick, showAvatars = true }: TrustBarProps) {
  return (
    <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-center sm:gap-8">
      <div className="hidden items-center gap-3 sm:flex">
        {showAvatars && (
          <div className="hidden -space-x-2 sm:flex">
            {trustAvatars.map((src, i) => (
              <img
                key={src}
                src={src}
                alt=""
                className="h-10 w-10 rounded-full border-2 border-background object-cover"
                style={{ zIndex: trustAvatars.length - i }}
              />
            ))}
          </div>
        )}
        <GoogleIcon className="h-8 w-8 shrink-0" />
        <div className="flex flex-col items-start">
          <div className="flex items-center gap-1.5">
            <div className="flex items-center gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="text-sm font-semibold text-foreground">5.0</span>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button
          onClick={() => {
            clickCta("Get a Free Mockup", "trust_bar");
            onCtaClick?.();
          }}
          className="h-12 rounded-full bg-gradient-to-r from-brand-blue to-[#ec4899] px-6 font-semibold text-white hover:opacity-90"
        >
          Get a Free Mockup
          <ArrowRight className="ml-1 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
